// INVARIANT(scriptera): СЦЕНА-ПРИМЕР НАРИСОВАНА В ДВУХ МЕСТАХ — веб (apps/web: components/auth/app-onboarding.tsx,
// components/auth/onboarding.css, components/mock-phone.{tsx,css}, app/[locale]/wizard-scene/[scene]/*,
// lib/scene-script.ts) и iOS (scriptera-app: ios/App/App/Kit/Scenes/*). Правишь вид, шаг, текст-раскладку, тайминг,
// цвет или размер — правь ОБА места тем же днём и сверяй кадры склейкой «веб | iOS» (~/ops/native-scenes). Причина:
// владелец 26.10.2026 — сцены в приложении нативные, «пиксель в пиксель». Канон: ~/projects/NATIVE-SCENES-TZ.md,
// docs/HOW-IT-WORKS.md §«Сцены-примеры».

// Живой знак: скруглённый квадрат (владелец 10.08.2026, был круг), молния ТЁМНАЯ —
// новый розовый #feb3c8 светлый, белая на нём пропадала. Молния СМЕЩЕНА от центра на 0.075·D влево-вниз (КАНОН —
// центрированная молния НЕ логотип; владелец, logo-icon-rules) и оттуда медленно
// дрейфует по «блуждающей» траектории (разные периоды X/Y; амплитуда 8%, периоды
// 3.2с/4.7с — выбор владельца 2026-07-12). Смещение 1:1 с LaunchScreen iOS
// (AppDelegate BrandMarkView: x −0.075·D, y +0.075·D) — веб продолжает картинку
// запуска без скачка. Стили — globals.css (.brand-bolt): лендинг, кабинет, витрина.
export function BrandBolt({ size = 32, tone = 'pink' }: { size?: number; /** ink — чёрный круг (Scriptera Run, владелец 2026-07-12) */ tone?: 'pink' | 'ink' }) {
  const bolt = size * 0.75; // молния ×2 от прежней: 48/64 от диаметра
  const half = bolt / 2;
  const off = size * 0.075; // канон-смещение молнии: влево (X) и вниз (Y)
  const amp = `${size * 0.08}px`;
  return (
    <span className="brand-bolt" style={{ width: size, height: size, ...(tone === 'ink' ? { background: '#191512' } : {}) }} aria-hidden>
      <span className="bb-x" style={{ '--bb-a': amp } as React.CSSProperties}>
        <span className="bb-y" style={{ '--bb-a': amp } as React.CSSProperties}>
          <svg width={bolt} height={bolt} viewBox="0 0 24 24" style={{ marginLeft: -half - off, marginTop: -half + off }}>
            <path d="M13 2 5 13h5l-1 9 8-12h-5l1-8z" fill="#141414" />
          </svg>
        </span>
      </span>
    </span>
  );
}

/** ГЛИФ ЗНАКА БЕЗ ПЛАШКИ (владелец 13.10.2026): та же молния, что в BrandBolt, — одним символом в строке текста,
 *  цветом текста, размером в высоту прописной (em от шрифта строки). Квадрата, смещения и дрейфа нет. */
export function BrandBoltGlyph({ className }: { className?: string }) {
  return (
    <svg className={className} width="1em" height="1em" viewBox="5 2 12 20" aria-hidden>
      <path d="M13 2 5 13h5l-1 9 8-12h-5l1-8z" fill="currentColor" />
    </svg>
  );
}

